
import React, { useState, useEffect, memo, useMemo, useRef } from 'react';
import ValuesStore from '../../store/values-store';
import utils from '../../dependencies/custom/react-utilities';
import { Space, Button, Tag, message, Tabs, Tooltip, Card } from 'antd';
import useEdit from '../../hooks/edit';
import useAdd from '../../hooks/add';
import useDelete from '../../hooks/delete';
import useExcel from '../../hooks/excel';
import Settings from '../../dependencies/custom/settings';
import CustomFunctions from '../../dependencies/custom/custom-functions';
import Utilities from '../../dependencies/custom/react-utilities';
import AppContainer from '../../components/container';
import Table from '../../components/table';
import table from '../../components/table';

const CourseMountConfig = (props) => {
    const valuesStore = ValuesStore();
    const [tableObj, setTableObj] = useState();
    const edit = useEdit('tables_metadata', 'table_name');//make this hook be aware of where to get tbl metadata 
    const add = useAdd('tables_metadata', 'table_name');
    const remountAddMeta = 'remountAddMeta';
    const remountAdd = useAdd(remountAddMeta, 'table_name');
    const [modalTitle, setModalTitle] = useState('');
    const [rerender, setRerender] = useState(false);
    const del = useDelete();




    function editRecord(record, tableRealName, tableName) {
        const storeKey = 'editableRecord';
        valuesStore.setValue(storeKey, record);
        edit.setTblName(tableName);
        edit.setData(record);
        edit.setRecordKey(storeKey);
        edit.setShowModal(true);
        edit.setSaveCompleted(false);
        setModalTitle(`Edit Item - ${tableRealName}`);
    }

    async function editOnOk() {
        edit.setLoading(true);
        let res = await edit.save(undefined,
            `${Settings.backend}/edit`,
            undefined,
            { tbl: edit.tblName, where: 'id', whereType: 'closed' },
        );
        edit.setLoading(false);
        setRerender(!rerender);
    }




    const colFilters = [
        {
            filter: 'session',
            sql: "SELECT session,alias FROM sessions",
            key: 'alias',
            value: 'session'
        },
        {
            filter: 'mounted_level',
            sql: "SELECT level FROM level",
            key: 'level',
            value: 'level'
        },
        {
            filter: 'which_program',
            sql: "SELECT distinct name FROM programs WHERE show_hide =1 ORDER BY name ",
            key: 'name',
            value: 'name'
        },
        {
            filter: 'program_exempted',
            sql: "SELECT distinct name FROM programs WHERE show_hide =1 ORDER BY name ",
            key: 'name',
            value: 'name'
        },
        {
            filter: 'semester_id',
            sql: 'SELECT semester,alias FROM semester',
            key: 'alias',
            value: 'semester'
        },
        {
            filter: 'semester',
            sql: 'SELECT semester,alias FROM semester',
            key: 'alias',
            value: 'semester'
        }
    ];

    useMemo(() => {
        console.log('looping');
    }, [add.saveCompleted, remountAdd.saveCompleted, edit.saveCompleted, del.saveCompleted]);

    async function addOnOk() {
        try {
            add.setLoading(true);
            await add.save();
            setRerender(!rerender);
            add.setLoading(false);
        } catch (err) {
            add.setLoading(false);
        }
    }


    function showAddModal(tableName, tableRealName) {
        setModalTitle(`Add New Item - ${tableRealName}`);
        add.setTblName(tableName);
        add.setShowModal(true);
        add.setSaveCompleted(false);
    }
    function afterDelete() {
        setRerender(!rerender);
    }

    function appendColumnActions(tableName, tableRealName, columns) {
        const action = {
            title: 'Action',
            key: 'action',
            render: (_, record) => {
                return <Space size="middle">
                    <Button className='btn-successx border-0x' onClick={e => editRecord(record, tableRealName, tableName)}><i className='fas fa-edit text-success' /></Button>
                    {del.confirm(
                        `${Settings.backend}/delete`,
                        record,
                        'Are you sure to delete this item',
                        { tableName, where: 'id', whereType: 'closed' },
                        <Button className='btn-dangerx border-0x'>  <i className='fas fa-trash text-danger' /></Button>,
                        undefined, undefined, undefined, afterDelete
                    )}
                </Space>
            },
        }
        columns?.push(action);
        return columns;
    }

    function view(tableName, tableRealName, endpoint, columns) {
        const cols = appendColumnActions(tableName, tableRealName, columns);
        return <>
            <Button onClick={e => showAddModal(tableName, tableRealName)} className='mb-2'>Add New</Button>
            <Table
                render={rerender}
                tableName={tableName}
                columns={cols}
                checkableFilters={colFilters}
                endpoint={endpoint}
                onTableObjectReady={(getTableObject) => {
                    setTimeout(() => {
                        // const tob = getTableObject();
                        // setTableObj(tob);
                    }, 500);
                }}
            />
        </>
    }

    const items = [
        {
            key: '1',
            label: 'GMC Exemptions',
            children: view('mounted_courses_general_exemptions', 'GMC Exemptions', `${Settings.backend}/get_data`, CustomFunctions.courseMountingConfigColumns()?.gmcExemptCols)
        },
        {
            key: '2',
            label: 'GMC Group Name',
            children: view('mounted_courses_general_group_names', 'GMC Group Name', `${Settings.backend}/get_data`, CustomFunctions.courseMountingConfigColumns()?.gmcGroupNameCols)           
        },
        {
            key: '3',
            label: 'GMC Rules',
            children: view('mounted_courses_general_rules', 'GMC Rules', `${Settings.backend}/get_data`, CustomFunctions.courseMountingConfigColumns()?.gmcRuleCols)            
        },
        {
            key: '4',
            label: 'MC Group Name',
            children: view('mounted_courses_group_names', 'MC Group Name', `${Settings.backend}/get_data`, CustomFunctions.courseMountingConfigColumns()?.mcGroupNameCols)            
        },
        {
            key: '5',
            label: 'MC Rule Names',
            children: view('mounted_courses_rules', 'GMC Rule Names', `${Settings.backend}/get_data`, CustomFunctions.courseMountingConfigColumns()?.mcRulesNameCols)            
        },
        {
            key: '6',
            label: 'MC Rules',
            children: view('mounted_courses_rules_details', 'MC Rules', `${Settings.backend}/get_data`, CustomFunctions.courseMountingConfigColumns()?.mcRuleCol)            
        }
    ]

    return (
        <>
            <AppContainer
                title="Course Mounting Configurations"
                extra={
                    <>

                    </>
                }

                children={
                    <div className='row'>
                        <div className='col-md-12 mb-2'>
                            <div className='table-responsive h-scrolling-wrapper'>
                                <Tabs defaultActiveKey="1" className='mt-3' type='card' items={items} />
                            </div>
                        </div>
                    </div>
                }

            />
            {add.addModal(modalTitle, addOnOk)}
            {edit.editModal(modalTitle, editOnOk)}
        </>
    );
}

export default memo(CourseMountConfig);